import { createClient } from '@supabase/supabase-js'
import { getRuntimeEnv } from './runtime-env'

const supabaseUrl = getRuntimeEnv('VITE_SUPABASE_URL')
const supabaseAnonKey = getRuntimeEnv('VITE_SUPABASE_ANON_KEY')

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[ISEN EDUCAE] Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no Environment do Dokploy (ou .env local)',
  )
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
)
